.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-width: 64.8rem;
}

.content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.settings-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 0;

  &:first-child {
    padding-top: 0;
  }

  &:not(:last-child) {
    border-bottom: 0.1rem solid var(--color-grey-7-5);
  }
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 1.6rem;
}

.header {
  font-size: 1.6rem;
  padding-bottom: 1.6rem;
  border-bottom: 0.1rem solid var(--color-grey-7-5);
}

.coming-soon {
  border-radius: var(--border-radius-medium);
  background: var(--color-grey-8);
  color: #f7f8f877;
  font-size: 1rem;
  text-transform: uppercase;
  padding: 0.4rem 0.8rem;
}
